import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "divider--green" }, null, -1)
const _hoisted_2 = { class: "header__bottom" }
const _hoisted_3 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LKFSelect = _resolveComponent("LKFSelect")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          alt: _ctx.t('header.siteLogo'),
          class: "header__logo",
          src: "/logo.png"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_LKFSelect, {
          "default-option": _ctx.selectedLocale,
          options: _ctx.selectOptions,
          class: "header__lang-select",
          "no-border": "",
          "not-searchable": "",
          placeholder: "Keel",
          "select-name": "langSelect",
          onChange: _ctx.onLanguageChange
        }, null, 8, ["default-option", "options", "onChange"])
      ])
    ])
  ]))
}